import { useEffect, useState } from 'react'
import {
  SimpleShowLayout,
  useRecordContext,
  Button,
  useRefresh,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { ExtranetContainer, StatusProgressV2 } from './utils'
import { CustomToolbar } from './utils'
import Typography from '@material-ui/core/Typography'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import { DynamicViewComponentPAC } from './tickets_common'
import { CustomFileDetailTable } from './components/file_upload'
import {
  Dialog,
  Grid,
  DialogTitle,
  DialogContent,
  Backdrop,
  CircularProgress,
  FormControl,
  InputAdornment,
  IconButton,
  Box,
  Paper,
  InputLabel,
  OutlinedInput,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'

import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Badge,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import { ExtCoproTicketCreateDialog } from './ext_coproprietaires/ticket_create_dialog'
import Api from './Apis/api.service'
import { Search } from '@mui/icons-material'
import config from './config'

const publicUrl = config.PUBLIC_URL
const useStyles = makeStyles({
  icons: {
    width: '32px',
    marginRight: '8px',
  },
  accordion: {
    boxShadow: 'none!important',
    margin: '16px auto!important',
    '&:not(.Mui-disabled), .MuiStepper-root': {
      backgroundColor: '#f2f2f2!important',
    },
    borderRadious: '1rem!important',
  },
  processCard: {
    border: 'none',
    boxShadow: 'none',
    '& .MuiCardContent-root': {
      padding: '0 16px!important',
    },
  },
  button: {
    padding: '8px !important',
    background: 'white !important',
    color: '#143A5F !important',
    border: '1px solid #143A5F !important',
    borderRadius: '5px !important',
    fontSize: '0.8125rem !important',
    '&:hover': {
      background: '#143A5F !important',
      color: '#ffffff !important',
    },
    '&:disabled': {
      color: '#66666699 !important',
      background: '#e6e5e5a8 !important',
      borderColor: '#e4e6ef !important',
    },
  },
})

const processIconsMapping = {
  'Petites interventions': 'default',
  Facturation: 'invoice',
  'Interventions urgentes': 'emergency',
  'Etat daté': 'calendar',
  'Pré état daté': 'calendar',
  Juridique: 'law',
  'Mise en concurrence': 'competition',
  'Visites et visios': 'home',
  'Action Copro Manager': 'megaphone',
}

const TicketDetailDialog = ({ ticket, process }) => {
  const [openTicketId, setOpenTicketId] = useState()

  return (
    <>
      <Grid
        item
        style={{
          marginLeft: 'auto',
          cursor: 'pointer',
        }}
        onClick={() => {
          setOpenTicketId(ticket.id)
        }}
      >
        <Badge
          style={{
            backgroundColor: '#143A5F',
            borderRadius: '1rem',
            padding: '2px',
          }}
        >
          <svg
            focusable="false"
            aria-hidden="true"
            viewBox="0 0 24 24"
            style={{ width: '15px', fill: 'white' }}
          >
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"></path>
          </svg>
        </Badge>
      </Grid>
      <Dialog
        open={openTicketId === ticket.id}
        onClose={() => {
          setOpenTicketId(null)
        }}
        maxWidth="md"
      >
        <DialogTitle>Détail du ticket</DialogTitle>
        <DialogContent>
          <Grid container>
            <Grid
              item
              md={7}
              style={{
                marginBottom: '16px',
              }}
            >
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Ticket n° :</TableCell>
                    <TableCell>{ticket.id}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Thématique :</TableCell>
                    <TableCell>{process.name}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Prestataire :</TableCell>
                    <TableCell>{ticket.providers}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Demande :</TableCell>
                    <TableCell>{ticket.created}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Dernière action :</TableCell>
                    <TableCell>{ticket.last_state_change}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell colspan={2}>
                      Si des fichiers ont été joints à la demande ou proposés
                      par le prestataire, vous les trouverez en cliquant sur la
                      petite icône "fichiers" associée au ticket, sur le plan
                      d'action.
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            <Grid item xs={12} sm={5}>
              <img
                style={{
                  width: '100%',
                }}
                src={`${publicUrl}/img/ext_coprosummary_modal.svg`}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  )
}
const TicketItem = ({ ticket, process }) => {
  const [file_dialog_data, setFileDialogData] = useState()

  return (
    <div key={ticket.id}>
      <ListItem alignItems="flex-start">
        <ListItemText
          primary={
            <Grid container direction="row" justifyContent="space-between">
              <Grid item xs={11}>
                <Typography>{`#${ticket.id} ${ticket.libelle}`}</Typography>
              </Grid>
              {ticket.file_with_context.length > 0 && (
                <Grid
                  item
                  style={{
                    marginLeft: 'auto',
                    cursor: 'pointer',
                    backgroundColor: '#143a60',
                    borderRadius: '1rem',
                    padding: '4px',
                    height: '20px',
                    position: 'relative',
                    width: '20px',
                    marginTop: '3px',
                  }}
                >
                  <img
                    src="/img/icons/file-present.svg"
                    style={{
                      width: '12px',
                      position: 'absolute',
                    }}
                    onClick={() => {
                      setFileDialogData(ticket.file_with_context)
                    }}
                  />
                </Grid>
              )}
              <TicketDetailDialog ticket={ticket} process={process} />
            </Grid>
          }
          secondary={
            <div>
              <StatusProgressV2 ticket={ticket} />
              <DynamicViewComponentPAC record={ticket} />
            </div>
          }
        />
      </ListItem>
      <Divider />
      {file_dialog_data && (
        <Dialog
          open={file_dialog_data}
          onClose={() => {
            setFileDialogData(null)
          }}
          maxWidth="md"
        >
          <DialogTitle>Documents</DialogTitle>
          <DialogContent>
            <Grid container>
              <Grid
                item
                // md={8}
                style={{
                  marginBottom: '16px',
                }}
              >
                <CustomFileDetailTable hideUrl={true} rows={file_dialog_data} />
              </Grid>
              <Grid item>
                <Grid item>
                  <img
                    style={{
                      width: '260px',
                    }}
                    src={`${publicUrl}/img/ext_coprosummary_files.svg`}
                  />
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      )}
    </div>
  )
}

const TicketAccordion = ({ source, process, title }) => {
  const classes = useStyles()

  return (
    <Accordion
      className={classes.accordion}
      defaultExpanded={false}
      disabled={process[source].length === 0}
    >
      <AccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>
        <List>
          {process[source].map((ticket) => (
            <TicketItem ticket={ticket} process={process} />
          ))}
        </List>
      </AccordionDetails>
    </Accordion>
  )
}

const CheckDataAvailable = (processes) => {
  let hasTickets = false
  processes.map((process) => {
    if (process.tickets.length || process.archived_tickets.length) {
      hasTickets = true
    }
  })
  return hasTickets
}
const Processes = ({ query, onlyMyRequests }) => {
  let { processes } = useRecordContext()
  const classes = useStyles()
  if (!processes) return null
  const sortedProcesses = [6, 4, 13, 15, 14, 5]
  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      top: '8px',
      right: '-29px',
      padding: '8px 9px',
      fontSize: '12px',
    },
  }))
  if (!CheckDataAvailable(processes)) {
    return <div style={{ paddingLeft: '1rem' }}> Aucun résultat trouvé !</div>
  }
  return (
    <div>
      {sortedProcesses.map((processId) => {
        const [process] = processes.filter((p) => p.id == processId)
        if (!process) {
          return null
        }
        var isHasTicket =
          process?.tickets?.length || process?.archived_tickets?.length

        if (query || onlyMyRequests) {
          if (isHasTicket) {
            return (
              <div key={process.id}>
                <Card className="processCard">
                  <CardContent
                    style={{
                      paddingBottom: '16px',
                      paddingTop: 0,
                    }}
                  >
                    <Typography variant="h5" component="h2">
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                        }}
                      >
                        <img
                          className={classes.icons}
                          src={`${
                            publicUrl +
                            `/img/icons/${
                              processIconsMapping[process.name]
                            }.svg`
                          }`}
                        />
                        {process.name}
                      </div>
                    </Typography>
                    <TicketAccordion
                      source="tickets"
                      process={process}
                      title={
                        process.tickets.length === 0 ? (
                          'Aucune demande en cours'
                        ) : (
                          <StyledBadge
                            badgeContent={process.tickets.length}
                            color="secondary"
                          >
                            Demandes en cours
                          </StyledBadge>
                        )
                      }
                    />
                    <TicketAccordion
                      source="archived_tickets"
                      process={process}
                      title={
                        process.archived_tickets.length === 0 ? (
                          'Aucune demande en cours'
                        ) : (
                          <StyledBadge
                            badgeContent={process.archived_tickets.length}
                            color="secondary"
                          >
                            Demandes archivées
                          </StyledBadge>
                        )
                      }
                    />
                  </CardContent>
                </Card>
              </div>
            )
          } else {
            return <></>
          }
        } else {
          return (
            <div key={process.id}>
              <Card className="processCard">
                <CardContent
                  style={{
                    paddingBottom: '16px',
                    paddingTop: 0,
                  }}
                >
                  <Typography variant="h5" component="h2">
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                      }}
                    >
                      <img
                        className={classes.icons}
                        src={`${
                          publicUrl +
                          `/img/icons/${processIconsMapping[process.name]}.svg`
                        }`}
                      />
                      {process.name}
                    </div>
                  </Typography>
                  <TicketAccordion
                    source="tickets"
                    process={process}
                    title={
                      process.tickets.length === 0 ? (
                        'Aucune demande en cours'
                      ) : (
                        <StyledBadge
                          badgeContent={process.tickets.length}
                          color="secondary"
                        >
                          Demandes en cours
                        </StyledBadge>
                      )
                    }
                  />
                  <TicketAccordion
                    source="archived_tickets"
                    process={process}
                    title={
                      process.archived_tickets.length === 0 ? (
                        'Aucune demande en cours'
                      ) : (
                        <StyledBadge
                          badgeContent={process.archived_tickets.length}
                          color="secondary"
                        >
                          Demandes archivées
                        </StyledBadge>
                      )
                    }
                  />
                </CardContent>
              </Card>
            </div>
          )
        }
      })}
    </div>
  )
}

const IntroText = (props) => {
  const classes = useStyles()
  const navigate = useNavigate()
  const record = useRecordContext(props)
  const [searchParams] = useSearchParams()
  const coproprietaire_id =
    searchParams.get('coproprietaire_id') || props.coproprietaire_id
  const [showDialogExtCoproTicketCreate, setShowDialogExtCoproTicketCreate] =
    useState(false)
  const toggleDialogExtCoproTicketCreate = () =>
    setShowDialogExtCoproTicketCreate(!showDialogExtCoproTicketCreate)
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
        }}
      >
        <ArrowBackIcon
          onClick={() => navigate(-1)}
          fontSize="large"
          sx={{
            padding: '2rem 1rem 0',
            cursor: 'pointer',
          }}
        />
        {record.copromatic_id && coproprietaire_id ? (
          <Box
            sx={{
              flex: 1,
              alignItems: 'center',
              display: 'flex',
              justifyContent: 'end',
              marginRight: '20px',
              marginTop: '25px',
            }}
          >
            <Button
              color="primary"
              size="large"
              variant="contained"
              onClick={toggleDialogExtCoproTicketCreate}
              disableElevation
              className={classes.button}
            >
              Demander une intervention
            </Button>

            <ExtCoproTicketCreateDialog
              {...props}
              copro_id={record.copromatic_id}
              copro_internal_id={record.copro_internal_id}
              coproprietaire_id={coproprietaire_id}
              show={showDialogExtCoproTicketCreate}
              setShow={setShowDialogExtCoproTicketCreate}
            />
          </Box>
        ) : null}
        <Typography
          variant="subtitle1"
          component="h2"
          style={{ padding: '1rem' }}
        >
          Vous pouvez suivre en temps réel les différents dossiers qui ont été
          initiés, jusqu'à leur clôture. En cas de question, notre Support
          Technique pourra vous informer sur l'état d'avancement du dossier,
          ainsi que votre Copro Manager dans le cadre de son travail avec le
          Conseil Syndical.
          <br />
        </Typography>
      </div>
    </>
  )
}

const SummaryActions = ({
  setQuery,
  query,
  setOnlyMyRequests,
  onlyMyRequests,
}) => {
  const handleChange = (event) => {
    setOnlyMyRequests(event.target.checked)
  }
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: { xs: 'column', sm: 'row' },
        width: { xs: '100%', sm: 'auto' },
        alignItems: { xs: 'baseline', sm: 'center' },
        padding: { xs: '10px', sm: '0px' },
        rowGap: { xs: '10px', sm: '0px' },
      }}
      component={Paper}
    >
      <FormControl
        variant="outlined"
        style={{
          flex: 1,
          marginRight: 10,
          width: '100%',
        }}
      >
        <InputLabel htmlFor="seachQuery">Rechercher</InputLabel>
        <OutlinedInput
          id="seachQuery"
          type={'text'}
          value={query}
          onChange={(e) => {
            setQuery(e.target.value)
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="icon-search" edge="end">
                <Search />
              </IconButton>
            </InputAdornment>
          }
          label="Search"
        />
      </FormControl>
      <FormControl>
        <FormControlLabel
          control={
            <Checkbox checked={onlyMyRequests} onChange={handleChange} />
          }
          label="Mes demandes uniquement"
        />
      </FormControl>
    </Box>
  )
}
export const CoproSummaryEdit = ({ syncWithLocation = true, ...props }) => {
  const refresh = useRefresh()
  const params = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(null)
  const [query, setQuery] = useState(searchParams.get('query'))
  const [onlyMyRequests, setOnlyMyRequests] = useState(false)
  const coproprietaire_id =
    searchParams.get('coproprietaire_id') || props.coproprietaire_id
  const copro_id = props.id || params.id
  const fetchData = async () => {
    setIsLoading(true)
    const res = await Api.extCoprosummary.get(copro_id, {
      coproprietaire_id,
      query,
      onlyMyRequests,
    })
    if (res.status == 200) {
      setData(res.data)
    } else {
      console.log({ res })
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [query, onlyMyRequests, coproprietaire_id])

  return (
    <>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
      >
        <Grid
          container
          spacing={0}
          direction="column"
          justifyContent="center"
          alignItems="center"
          xs={12}
          md={12}
        >
          <Grid item style={{ width: '100%', marginBottom: '10px' }}>
            <SummaryActions
              setQuery={setQuery}
              query={query}
              setOnlyMyRequests={setOnlyMyRequests}
              onlyMyRequests={onlyMyRequests}
            />
          </Grid>
        </Grid>
      </Grid>

      {isLoading && (
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      {!isLoading && (
        <ExtranetContainer xs={12} md={12}>
          <Box component={Paper}>
            <SimpleShowLayout
              toolbar={<CustomToolbar />}
              record={data}
              sx={{ minHeight: 250 }}
            >
              <IntroText coproprietaire_id={coproprietaire_id} />
              <Processes
                {...props}
                query={query}
                onlyMyRequests={onlyMyRequests}
              />
            </SimpleShowLayout>
          </Box>
        </ExtranetContainer>
      )}
    </>
  )
}
